export const retrieve = (item, props) => {
  let value = { ...item };
  props.forEach(prop => {
    if (!value || !prop) {
      return;
    }
    value = value[prop];
  });

  return Array.isArray(value) ? value.length : value;
};

export const filterResults = (filters, data, columnDirectory) => {
  if (!filters) return data;
  const fieldValues = Object.keys(columnDirectory).map(
    field => columnDirectory[field].dataIndex
  );
  return data.filter(row => {
    return filters.every(filter => {
      const reg = new RegExp(filter.value, 'gi');
      return fieldValues.some(
        field => !!String(retrieve(row, field.split('.'))).match(reg)
      );
    });
  });
};

export const fieldSort = (data, field, direction, num) => {
  const dataSet = [...data];
  if (!field) {
    return dataSet;
  }
  const modifier = direction === 'ascend' ? 1 : -1;
  const sorterKeys = field.split('.');

  dataSet.sort((a, b) => {
    a = num ? parseInt(retrieve(a, sorterKeys)) : retrieve(a, sorterKeys);
    b = num ? parseInt(retrieve(b, sorterKeys)) : retrieve(b, sorterKeys);
    if (a < b || (num && b && !a)) {
      return 1 * modifier;
    }
    if (a > b || (num && a && !b)) {
      return -1 * modifier;
    }
    return 0;
  });

  return dataSet;
};
